export function validate(record) {
  const errors = []

  if (!record.chave || !String(record.chave).trim()) {
    errors.push({ field: 'chave', message: 'O campo "Chave" é obrigatório' })
  }
  if (!record.nome || !String(record.nome).trim()) {
    errors.push({ field: 'nome', message: 'O campo "Nome" é obrigatório' })
  }
  if (!record.tabela || !String(record.tabela).trim()) {
    errors.push({ field: 'tabela', message: 'O campo "Tabela" é obrigatório' })
  }

  // o LtsJsonArea trabalha com objeto; o BE persiste a definição como texto
  let definicao = record.definicao
  if (definicao && typeof definicao === 'object') {
    definicao = JSON.stringify(definicao, null, 2)
  }
  if (!definicao || !String(definicao).trim() || definicao === '{}') {
    errors.push({ field: 'definicao', message: 'A definição JSON é obrigatória' })
  } else {
    try {
      JSON.parse(definicao)
    } catch (e) {
      errors.push({ field: 'definicao', message: 'A definição não é um JSON válido' })
    }
  }

  const result = {
    ok: errors.length === 0,
    errors,
    record: Object.assign({}, record, { definicao }),
  }

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
